import React from 'react';
import parse from 'html-react-parser';
import { renderMustacheTemplate } from '../../helpers/content';
import { contentDataSelector } from '../../redux/selectors';
import { useKenticoContentErrorNotify } from '../../kentico/contentErrors';
import { useAppSelector } from '../../redux/hooks';
export function MustacheWithHtml({ item, template }) {
    const contentErrorNotify = useKenticoContentErrorNotify();
    const contentData = useAppSelector(contentDataSelector);
    const value = renderMustacheTemplate({
        template,
        data: contentData,
        handleError: (message) => contentErrorNotify(message, { contentItem: item }),
    });
    const result = parse(value);
    return React.createElement(React.Fragment, null, result);
}
//# sourceMappingURL=MustacheWithHtml.js.map